import(/* webpackMode: "eager" */ "/src/src/app/global-error.tsx");
